<template>
  <!-- 发票查询 -->
  <div class="page-container-manage page-container-booking" id="ebOrderContainer">
    <el-form
      :model="searchData"
      ref="ruleFormRef"
      class="form-panel"
      label-position="top"
      :validateOnRuleChange="false"
    >
      <el-row class="content-panel top-radius">
        <el-row :gutter="22">
          <el-col :span="5">
            <el-form-item :label="$t('searchData.invoiceSerialNo')">
              <el-input
                size="mini"
                v-model="searchData.invoiceSerialNo"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('searchData.invoiceNo')">
              <el-input size="mini" v-model="searchData.invoiceNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('searchData.issuedDateFrom')">
              <el-date-picker
                v-model="searchData.issuedDateFrom"
                align="right"
                type="date"
                style="width: 100%"
                size="mini"
                default-time="00:00:00"
                placeholder=""
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('searchData.issuedDateTo')">
              <el-date-picker
                v-model="searchData.issuedDateTo"
                align="right"
                type="date"
                style="width: 100%"
                size="mini"
                default-time="23:59:59"
                placeholder=""
                :picker-options="pickerOptions"
                @change="changeissuedDateTo"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('searchData.invoiceType')">
              <el-associate
                style="width: 100%"
                :columns="associate_columns_invoice"
                :query-method="associate_queryMethod_invoice"
                class="input_length"
                clearable
                :query-length="0"
                :default-first-option="true"
                label-prop="invoiceTypeName"
                value-prop="invoiceTypeCode"
                placeholder=""
                v-model="searchData.invoiceType"
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-button class="el-button-search" type="primary" size="small" plain @click="queryForm"
          >{{$t('button.query')}}</el-button
          >
          <el-button type="primary" size="small" plain @click="resetForm"
          >{{$t('button.reset')}}
          </el-button
          >
        </el-row>
        </el-row>
        <!-- 表格-start -->

        <el-row class="table-panel" style="margin-top: 15px">
          <hot-table
            ref="ebOrderTableRef"
            :data-source="bcInvoiceTableDataSource"
            :settings="bcInvoiceTableSettings"
            col-settings-key="bcInvoice"
            @rowDblclick="bcInvoiceRowClick"
          >
            <hot-column
              :has-tip="true"
              :title="$t('bcInvoice.invoiceSerialNo')"
              data="invoiceSerialNo"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              :title="$t('bcInvoice.invoiceNo')"
              data="invoiceNo"
              width="150"
            >
              <!-- <el-input-editor hot-editor data="invoiceNo"/> -->
            </hot-column>

            <hot-column
              :has-tip="true"
              :title="$t('bcInvoice.invoiceCode')"
              data="invoiceCode"
              width="150"
            >
              <!-- <el-input-editor hot-editor data="invoiceCode"/> -->
            </hot-column>

            <hot-column
              :has-tip="true"
              :title="$t('bcInvoice.issuedDate')"
              data="issuedDate"
              date-format="YYYY-MM-DD"
              width="150"
            >
              <!-- <el-input-editor hot-editor data="issuedDate"/> -->
            </hot-column>
            <hot-column
              :has-tip="true"
              :title="$t('bcInvoice.invoiceType')"
              data="invoiceType"
              width="150"
              dictName="MD_CODE_BC_INVOICE_TYPE"
            >
              <!-- <el-input-editor hot-editor data="invoiceType"/> -->
            </hot-column>
            <hot-column
              :has-tip="true"
              :title="$t('bcInvoice.settleCustName')"
              data="settleCustName"
              width="150"
            >
              <!-- <el-input-editor hot-editor data="settleCustName"/> -->
            </hot-column>
            <hot-column
              :has-tip="true"
              :title="$t('bcInvoice.taxpayerIdentificatioNo')"
              data="taxpayerIdentificatioNo"
              width="150"
            >
              <!-- <el-input-editor hot-editor data="taxpayerIdentificatioNo"/> -->
            </hot-column>
            <hot-column
              :has-tip="true"
              :title="$t('bcInvoice.invoiceAmount')"
              data="invoiceAmount"
              width="150"
            >
              <!-- <el-input-editor hot-editor data="invoiceAmount"/> -->
            </hot-column>
          </hot-table>
        </el-row>

        <!-- 分页start -->
        <div class="pg_div">
          <el-pagination
            :current-page="pageConfig.currentPage"
            :layout="pageConfig.layout"
            :page-size="pageConfig.pageSize"
            :page-sizes="pageConfig.pageSizes"
            :total="pageConfig.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>

        <!-- 分页end -->
        <!-- 表格-end -->
    </el-form>
  </div>
</template>

<script>
import { queryInvoice } from "@/api/queryMainSystem";
import { queryCarrierInfo , queryDictRows, queryInvoiceType } from "@/api/commonService";

export default {
  data() {
    return {
      invoiceTypeList: [], //发票类型
      //日期设置
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      bcInvoice: {
        invoiceSerialNo: null,
        invoiceNo: null,
        invoiceCode: null,
        issuedDate: null,
        invoiceType: null,
        notify: null,
        taxpayerIdentificatioNo: null,
        invoiceAmount: null,
      },

      searchData: {
        isDetail: null,
        invoiceSerialNo: null,
        invoiceNumber: null,
        issuedDateFrom: null,
        issuedDateTo: null,
        invoiceType: null,
        overseasAgent: "N",
      },

      // 分页
      pageConfig: {
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        pageSize: 100,
        pagerCount: 100,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
      },
      // 发票类型联想控件
      associate_columns_invoice: [
        {
          title: "开票类型",
          field: "invoiceTypeName",
        },
        {
          title: "税率",
          field: "taxRate",
        }
      ],
      // 表格校验
      ebOrderRules: {},
      // 表格数据
      bcInvoiceTableDataSource: [],
      // 表格设置
      bcInvoiceTableSettings: {
        height: 520,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      pageID: {}
    };
  },
  async created() {

  },
  mounted() {
    let self = this;
    self.queryDictRows();
    // 监听外层容器div宽度的变化，做表格自适应

    this.bcInvoiceTableSettings.height = document.body.clientHeight - 100 -120;
  },
  methods: {
    bcInvoiceRowClick(val) {
      let row = val.record;
      this.$router.push({
        name: 'InvoiceDetail',
        params: {
          ebInvoiceId: row.bcInvoiceId,
          type: 'edit'
        }
      })
    },
    changeissuedDateTo() {
      let self = this;
      self.searchData.issuedDateTo = new Date(self.searchData.issuedDateTo.getTime() + 1000 * 24 * 3600 - 100)
    },
    //暂时修改为MD_CODE_BC_INVOICE_TYPE
    queryDictRows() {
      let self = this;
      queryDictRows("MD_CODE_DICT$MD_INVOICE_TYPE").then((res) => {
        self.invoiceTypeList = res.MD_INVOICE_TYPE;
         let dict = [];
        res.MD_INVOICE_TYPE.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          dict.push(param);
        });
        console.log(dict)
        self.$hotTableUtils.registDict({
          'MD_INVOICE_TYPE': dict,
        });
      });
    },
    //点击
    clickModule(e) {
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      let self = this;
      self.queryStatusPage();
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageConfig.currentPage = val;
      let self = this;
      self.queryStatusPage();
    },
    // 单击行事件
    rowClick(val) {
      let self = this;
      self.currentEbOrder = val.record;
    },
    // tab切换事件
    handleClick(tab, event) {
      let self = this;
      self.pageConfig.currentPage = 1;
      self.queryStatusPage();
    },
    queryStatusPage() {
      let self = this;
      self.queryForm();
    },
    //重置搜索框
    resetForm() {
      this.searchData = {};
    },
    //查询
    queryForm() {
      let self = this;
      self.queryButton = 2;
      let num = 0;
      for (let s in self.searchData) {
        if (self.searchData[s] !== null) {
          num++;
        } else {
          delete self.searchData[s]
        }
      }
      if (num === 0) {
        self.$coreMethods.message("warning", "至少输入一个查询条件");
      } else {
        self.searchData.isDetail = "N";
        self.searchData.overseasAgent = "N";
        self.searchData.currentPage = self.pageConfig.currentPage;
        self.searchData.pageSize = self.pageConfig.pageSize;
        //将日期向后一天
        self.searchData.issuedDateEnd = self.searchData.issuedDateTo +  3600 * 1000 * 24;
        queryInvoice(self.searchData).then((res) => {
          if (res.success) {
            if (res.records) {
              self.bcInvoiceTableDataSource = res.records.records;
              self.pageConfig.total = res.records.totalRecord;
            }
            if (res.records.totalRecord === 0){
              self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
            }else {
              self.$coreMethods.message("success", "查询成功！");
            }
          }
        });
      }
    },
    // 发票类型联想控件数据源
    associate_queryMethod_invoice({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          invoiceTypeName0: "%" + keyword + "%",
          invoiceTypeName1: "%" + keyword + "%",
          isDeleted2: "0",
        };
      }
      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdInvoiceType.taxRate"],
        mainModelName: "CTS_ILPMdInvoiceType",
        tag: "CTS_ILP_es",
        where:
          "((CTS_ILPMdInvoiceType.invoiceTypeName LIKE :invoiceTypeName0 OR CTS_ILPMdInvoiceType.invoiceTypeName LIKE :invoiceTypeName1) AND CTS_ILPMdInvoiceType.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdInvoiceType.createOffice",
          "CTS_ILPMdInvoiceType.createOfficeName",
          "CTS_ILPMdInvoiceType.createTime",
          "CTS_ILPMdInvoiceType.creatorName",
          "CTS_ILPMdInvoiceType.invoiceNoType",
          "CTS_ILPMdInvoiceType.invoiceTypeCode",
          "CTS_ILPMdInvoiceType.invoiceTypeName",
          "CTS_ILPMdInvoiceType.isActive",
          "CTS_ILPMdInvoiceType.isDeleted",
          "CTS_ILPMdInvoiceType.lastModifierId",
          "CTS_ILPMdInvoiceType.lastModifierName",
          "CTS_ILPMdInvoiceType.lastModifyOffice",
          "CTS_ILPMdInvoiceType.lastModifyOfficeName",
          "CTS_ILPMdInvoiceType.lastModifyTime",
          "CTS_ILPMdInvoiceType.mdInvoiceTypeId",
          "CTS_ILPMdInvoiceType.principalGroupCode",
          "CTS_ILPMdInvoiceType.recordVersion",
          "CTS_ILPMdInvoiceType.rpFlag",
          "CTS_ILPMdInvoiceType.settleOffice",
          "CTS_ILPMdInvoiceType.settleOfficeName",
          "CTS_ILPMdInvoiceType.taxRate",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryInvoiceType(data).then((res) => {
          console.log("queryInvoiceType", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
  },
};
</script>

<style scoped lang="less">
</style>
